import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const { pathname } = useLocation();
  const en = pathname.startsWith("/en");
  const t = en
    ? { title: "Page not found", body: "The page you are looking for does not exist or has been moved.", home: "Back to home", lib: "Go to the library", homeTo: "/en", libTo: "/en/library" }
    : { title: "Página no encontrada", body: "La página que buscas no existe o ha sido movida.", home: "Volver al inicio", lib: "Ir a la biblioteca", homeTo: "/", libTo: "/biblioteca" };

  return (
    <>
      <Helmet>
        <title>{`${t.title} | Luis ROC`}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <main className="min-h-screen flex items-center justify-center dark bg-background px-4">
        <div className="text-center max-w-md mx-auto">
          <p className="text-7xl font-bold mb-4 text-foreground tracking-tight">404</p>
          <h1 className="text-2xl font-semibold mb-4 text-foreground">{t.title}</h1>
          <p className="text-muted-foreground mb-8">{t.body}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to={t.homeTo} className="inline-flex items-center justify-center rounded-xl bg-foreground px-6 py-3 font-medium text-background transition-opacity hover:opacity-90">
              {t.home}
            </Link>
            <Link to={t.libTo} className="inline-flex items-center justify-center rounded-xl border border-border px-6 py-3 font-medium text-foreground transition-colors hover:bg-card">
              {t.lib}
            </Link>
          </div>
        </div>
      </main>
    </>
  );
};

export default NotFound;
